export const itemPlannerWeekLength = 7;
